import TitleBar from "../components/TitleBar/TitleBar";
import { CommandCategory, SearchableList } from "../components/SearchableList";
import { useEffect, useRef, useState } from "react";
import { FaSearch } from "react-icons/fa";

import "./Commands.css";

export function Commands() {
    const [searchText, setSearchText] = useState("");
    const [search, setSearch] = useState("");
    const [commandCategories, setCommandCategories] = useState<
        CommandCategory[]
    >([]);

    useEffect(() => {
        fetch(`${import.meta.env.VITE_SERVER_URL}/data/commands.json`)
            .then((response) => response.json())
            .then((json) => {
                setCommandCategories(json.categories);
            })
            .catch((error) => {
                console.error("Error fetching commands data:", error);
            });

        const params = new URLSearchParams(window.location.search);
        const searchParam = params.get("search");
        if (searchParam) {
            setSearchText(searchParam);
            setSearch(searchParam);
        }
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => setSearch(searchText), 500);
        return () => clearTimeout(timeout);
    }, [searchText]);

    return (
        <>
            <TitleBar title="Mythic Shop">
                <input
                    className="commands-search-input"
                    type="text"
                    onChange={(ev) => setSearchText(ev.target.value)}
                    value={searchText}
                    placeholder="Search Commands"
                />
                <button
                    className="commands-search-button"
                    onClick={() => {
                        console.log("Click");
                    }}
                >
                    <FaSearch />
                </button>
            </TitleBar>
            <div className="info-page">
                {commandCategories.map((category) => {
                    if (category.enabled === false) return null;
                    return (
                        <SearchableList
                            key={category.name}
                            search={search.toLowerCase()}
                            category={category}
                        />
                    );
                })}
            </div>
        </>
    );
}
